// extracted by mini-css-extract-plugin
var _1 = "FlatTableRow-moduleFlatTableRow__huRJn TableComponent-modulerow__xPAo4";
export { _1 as "FlatTableRow" }
